import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconDragGripHorizontal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 7.5C6.5 6.67157 5.82843 6 5 6C4.17157 6 3.5 6.67157 3.5 7.5C3.5 8.32843 4.17157 9 5 9C5.82843 9 6.5 8.32843 6.5 7.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 15C12.8284 15 13.5 15.6716 13.5 16.5C13.5 17.3284 12.8284 18 12 18C11.1716 18 10.5 17.3284 10.5 16.5C10.5 15.6716 11.1716 15 12 15Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 6C19.8284 6 20.5 6.67157 20.5 7.5C20.5 8.32843 19.8284 9 19 9C18.1716 9 17.5 8.32843 17.5 7.5C17.5 6.67157 18.1716 6 19 6Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 16.5C6.5 15.6716 5.82843 15 5 15C4.17157 15 3.5 15.6716 3.5 16.5C3.5 17.3284 4.17157 18 5 18C5.82843 18 6.5 17.3284 6.5 16.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 15C19.8284 15 20.5 15.6716 20.5 16.5C20.5 17.3284 19.8284 18 19 18C18.1716 18 17.5 17.3284 17.5 16.5C17.5 15.6716 18.1716 15 19 15Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 7.5C13.5 6.67157 12.8284 6 12 6C11.1716 6 10.5 6.67157 10.5 7.5C10.5 8.32843 11.1716 9 12 9C12.8284 9 13.5 8.32843 13.5 7.5Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconDragGripHorizontal as ReactComponent };
